export enum MachineEventTypeEnum {
    doorOpened = 0,
    doorClosed = 1,
    reboot = 2,
    shutdown = 3,
}

export function GetI18nStringFromMachineEventType(val: MachineEventTypeEnum): string {
    return `enum.machineEventsType.${MachineEventTypeEnum[val]}`;
}
